import _ from "lodash";
import {LOGO_IMAGE_DETAIL} from "../constants/shopify.constant";

export {
    prepareShopifyProductPriceList,
}

const prepareShopifyProductPriceList = (printfulProductsPriceInfo, printfulProductsPricesList, existingProductPrices) => {
    const productPrices = existingProductPrices || {};
    // const productPrices = {};
    const printfulProductsPricesMap = _.keyBy(printfulProductsPricesList, "product_id");

    _.forEach(printfulProductsPriceInfo?.products, product => {
        if (product.sync === "added") {
            const printfulProductPrice = printfulProductsPricesMap[product.product_id];
            productPrices[product.product_id] = product;
            productPrices[product.product_id].variants = printfulProductPrice?.variants || [];

            delete product.sync;
            delete printfulProductPrice.sync;
        }
    });

    return productPrices;
}
